import {AlertButton} from "../../../../shared/component/button/AlertButton"
import {Feature} from "../../../Feature"
import {ManageAccess} from "../../../management/component/ManageAccess"
import {useRouterNodeReload} from "../../api/NodeHook"
import {KeeperOneRequest} from "../../api/NodeType"

type Props = {
    request: KeeperOneRequest,
    cluster: string,
    size?: "small" | "medium",
}

export function KeeperReloadButton(props: Props) {
    const {request, cluster, size} = props
    const reload = useRouterNodeReload(cluster)

    return (
        <ManageAccess feature={Feature.ManageNodeKeeperReload}>
            <AlertButton
                size={size}
                label={"Reload"}
                title={`Make a reload of ${request.host}?`}
                description={`It will reload postgres config, it doesn't have any downtime. It won't help if pending 
                restart is true, some parameters require postgres restart.`}
                loading={reload.isPending}
                onClick={() => reload.mutate(request)}
            />
        </ManageAccess>
    )
}
